
export interface IEmpListByVehicleRequestDto {
  orgId: string;
  vehicleTypeId: number;
  sortColumn: string;
  sortOrder: number;
  pageNo: number;
  noOfRecords: number;
  orgVehicleTypeMapId: number;
  isFirstLoad: boolean;
  isDefaultRequired: boolean;
  isMilesDoneRequired: boolean;
  userId:number;
}


export class EmpListByVehicleRequestDto implements IEmpListByVehicleRequestDto {
  orgId: string;
  vehicleTypeId: number;
  sortColumn: string;
  sortOrder: number;
  pageNo: number;
  noOfRecords: number;
  orgVehicleTypeMapId: number = 0;
  isFirstLoad: boolean = false;
  isDefaultRequired: boolean = false;
  isMilesDoneRequired: boolean = false;
  requestType: number = 0;
  userId:number;
  constructor(orgId: string,
    vehicleTypeId: number,
    sortColumn: string,
    sortOrder: number,
    pageNo: number,
    noOfRecords: number) {
    this.orgId = orgId;
    this.vehicleTypeId = vehicleTypeId;
    this.sortColumn = sortColumn;
    this.sortOrder = sortOrder;
    this.pageNo = pageNo;
    this.noOfRecords = noOfRecords;
  }

}


export interface IEmpVehicleCounterRequestDto {
  orgId: string;
}


export class EmpVehicleCounterRequestDto implements IEmpVehicleCounterRequestDto {
  orgId: string;
  constructor(orgId: string) {
    this.orgId = orgId;
  }

}
